const formRow = [
  {
    span: 24,
    label: '规则顺序',
    component: 'ARadioGroup',
    prop: 'mergeType',
    defaultValue: 2,
    radioList: [
      { label: '先按时间顺序,后按显示顺序', value: 2 },
      { label: '先按显示顺序,后按时间顺序', value: 3 }
    ]
  },
  {
    span: 24,
    label: '时间顺序',
    component: 'ARadioGroup',
    prop: 'timeOrder',
    defaultValue: 'publicOrder-1',
    radioList: [
      { label: '最新申请', value: 'applicationOrder-1' },
      { label: '最早申请', value: 'applicationOrder-2' },
      { label: '最新公开', value: 'publicOrder-1' },
      { label: '最早公开', value: 'publicOrder-2' }
    ]
  },
  {
    span: 24,
    label: '显示顺序',
    component: 'AMultipleSelect',
    prop: 'countryOrder',
    multipleList: [
      {
        prop: '1',
        placeholder:'请选择',
        defaultValue: 'cn',
        list: [
          {label: '中国', value: 'cn'},
          {label: '美国', value: 'us'},
          {label: '日本', value: 'jp'},
          {label: '俄罗斯', value: 'ru'},
          {label: '韩国', value: 'kr'},
          {label: '法国', value: 'fr'},
          {label: '英国', value: 'gb'},
          {label: '瑞士', value: 'ch'},
          {label: '德国', value: 'de'},
          {label: 'EPO', value: 'ep'},
          {label: 'WIPO', value: 'wo'}
        ]
      },
      {
        prop: '2',
        placeholder:'请选择',
        defaultValue: 'us',
        list: [
          {label: '中国', value: 'cn'},
          {label: '美国', value: 'us'},
          {label: '日本', value: 'jp'},
          {label: '俄罗斯', value: 'ru'},
          {label: '韩国', value: 'kr'},
          {label: '法国', value: 'fr'},
          {label: '英国', value: 'gb'},
          {label: '瑞士', value: 'ch'},
          {label: '德国', value: 'de'},
          {label: 'EPO', value: 'ep'},
          {label: 'WIPO', value: 'wo'}
        ]
      },
      {
        prop: '3',
        placeholder:'请选择',
        defaultValue: 'jp',
        list: [
          {label: '中国', value: 'cn'},
          {label: '美国', value: 'us'},
          {label: '日本', value: 'jp'},
          {label: '俄罗斯', value: 'ru'},
          {label: '韩国', value: 'kr'},
          {label: '法国', value: 'fr'},
          {label: '英国', value: 'gb'},
          {label: '瑞士', value: 'ch'},
          {label: '德国', value: 'de'},
          {label: 'EPO', value: 'ep'},
          {label: 'WIPO', value: 'wo'}
        ]
      }
    ]
  },
]

const formRow1 = [
  {
    span: 24,
    label: '',
    component: 'ARadioGroup',
    prop: 'publicOrder',
    defaultValue: 1,
    radioList: [
      { label: '最新公开', value: 1 },
      { label: '最早公开', value: 2 }
    ]
  },
]

module.exports = {
  formRow,
  formRow1
}